import * as React from 'react';
import { DragSource } from 'react-dnd';
import { compose } from 'redux';
import { Wrapper, Preview, PreviewThumbnail } from './StyledComponents';

class DraggableSource extends React.PureComponent {
  previewRef;

  componentDidMount() {
    const { connectDragPreview } = this.props;
    connectDragPreview(this.previewRef);
  }

  // TODO: DONT UNDERSTAND HOW ITS WORK: document, params - what is this condition? (display clip on thumbnail)
  get isLinkid() {
    const { children } = this.props;

    if (!(children && children.props)) return false;
    const { linkID, params } = this.props;
    return linkID && params && !params.linkid && linkID;
  }

  render() {
    const { connectDragSource, className, isDragging, children, thumbnail, isMultiplyDND, isMiniThumbnail } =
      this.props;

    const {
      props: { selected: childrenSelected },
    } = children;

    return connectDragSource(
      <div className={className} style={{ opacity: isDragging ? 0.3 : 1 }}>
        {children}
        {isMiniThumbnail ? (
          <Wrapper>
            <Preview
              hasActiveStyle={isMultiplyDND}
              hasLinkFolderstyle={this.isLinkid}
              hasActiveChildrenStyle={childrenSelected}
              ref={(el) => {
                this.previewRef = el;
              }}
            >
              {thumbnail ? <PreviewThumbnail loading="lazy" src={thumbnail} alt="" /> : null}
            </Preview>
          </Wrapper>
        ) : null}
      </div>,
    );
  }
}

const draggableSource = (itemType) => ({
  beginDrag(props) {
    const { id, params = {}, onBeginDrag } = props;
    // eslint-disable-next-line no-unused-expressions
    onBeginDrag && onBeginDrag();
    return { id, ...params, itemType };
  },
  isDragging(props, monitor) {
    return monitor.getItem().id === props.id;
  },
  canDrag(props) {
    return !props.readOnly;
  },
  endDrag({ onEndDrag }, monitor) {
    if (onEndDrag) {
      onEndDrag(monitor.getDropResult());
    }
  },
});

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    connectDragPreview: connect.dragPreview(),
  };
}

export const DnDItemSource = (name) => compose(DragSource(name, draggableSource(name), collect))(DraggableSource);
